import { logEvent } from 'firebase/analytics';
import { analytics } from './firebase';
import { parseGaIds } from './ga-cookies';

/**
 * GA4 events.
 *
 * Firebase Analytics has been initialised since day one but nothing ever
 * called logEvent, so the property only recorded page_view / session_start /
 * first_visit. Every revenue question had to be answered by hand out of
 * Stripe. These helpers close that gap.
 *
 * Every call is best-effort. Ad blockers routinely kill the analytics script,
 * and a throw in here would take down a checkout or a roast submission.
 */
export function track(name: string, params: Record<string, unknown> = {}): void {
  try {
    logEvent(analytics, name, params);
  } catch (err) {
    console.debug('analytics event dropped:', name, err);
  }
}

/**
 * The GA4 client and session IDs for this visit (cookie formats in ga-cookies.ts).
 *
 * These travel with a checkout so the server-side purchase event lands in the
 * same GA4 session as the visit that produced it. Without them every sale
 * shows up as (direct) / (none) and the whole point is lost.
 *
 * Both come back undefined when analytics is blocked or the cookies haven't
 * been written yet. The purchase still records — just unattributed.
 */
export function getGaIds(): { clientId: string | undefined; sessionId: string | undefined } {
  return parseGaIds(document.cookie, analytics.app.options.measurementId);
}
